export const deepClone = (val?: object): any => {
    if (val === undefined || val === null || typeof(val) !== "object"){
        return val;
    }
    if (Array.isArray(val)){
        return val.map(v => deepClone(v));
    }
    return JSON.parse(JSON.stringify(val));
};